import { Component, ElementRef, OnInit, ViewChild, OnDestroy, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { ServicesProvider } from 'src/providers/services';
import { FCM } from 'cordova-plugin-fcm-with-dependecy-updated/ionic/ngx';
import { Platform, ModalController, LoadingController } from '@ionic/angular';
import { VcalertPage } from 'src/app/vcalert/vcalert.page';
import { CommonService } from 'src/providers/common';
import { Gesture, GestureController } from '@ionic/angular';
import { AdvertisementPage } from '../advertisement/advertisement.page';
import { AddCall } from 'src/providers/addvCall';
import { HomeVcNotificationPage } from './home-vc-notification/home-vc-notification.page'
import { ChangeLanguagePage } from '../change-language/change-language.page';
import { PopupalertPage } from '../popupalert/popupalert.page';
import { VideoCallService } from 'src/providers/videocall';
import { ELocalNotificationTriggerUnit, LocalNotifications } from '@ionic-native/local-notifications/ngx';
import { Subscription } from 'rxjs';
import { LocationAccuracy } from '@ionic-native/location-accuracy/ngx';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { AndroidPermissions } from '@ionic-native/android-permissions/ngx';
//import { AuthenticationService } from 'src/providers/authentication';


import { Globalization } from '@ionic-native/globalization/ngx';
import { TranslateService } from '@ngx-translate/core';
import { formatDate } from '@angular/common';
import * as moment from 'moment';

import { VaccinepopupPage } from '../vaccination-schedule/vaccinepopup/vaccinepopup.page';
// import { TranslateService } from '@ngx-translate/core';

declare var CID: any;
declare var cordova: any;



@Component({
  selector: 'app-home',
  templateUrl: './home.page.html',
  styleUrls: ['./home.page.scss'],
})

export class HomePage implements OnInit, OnDestroy {
  private apiSubscriptions: Subscription[] = [];
  // for translate
  // public slideOpts: any = this.addCall.selectedLanguage == 'en' ? 'ltr' : 'rtl' ;

  media: any;

  public title!: string; audio: any;
  public title_2!: string;
  public description!: string;
  public name!: string;
  public language: string;


  homeToggle: any;
  rate: any;
  presentView: string;

  URL: string;

  homePageHead: boolean;
  homePageBody: boolean;

  hideSlide: boolean;
  showSlide: boolean;
  patientBasicDetails: any;
  storeNoOfApmnts: any; membergender: any;
  totalNotificationsCount: any;

  @ViewChild('rect') rectangle: ElementRef;
  @ViewChild('audioOption') audioPlayerRef: ElementRef;
  element: Gesture;
  dynClass: string;
  addImg: any;
  tymVal: any;
  NotificationCount: any = [];
  PatientProfileDetails: any;
  @Output() sendNotification = new EventEmitter<any>();
  localPushNotificationTitle = '';
  localPushNotificationContent = '';

  constructor(
    public modalCtrl: ModalController,
    private platform: Platform,
    public router: Router,
    private services: ServicesProvider,
    private fcm: FCM,
    private gestureCtrl: GestureController,
    public addCall: AddCall,
    public common: CommonService,
    //public auth: AuthenticationService
    public videocall: VideoCallService,
    private globalization: Globalization,
    private _translate: TranslateService,
    private loadingController: LoadingController,
    private localNotification: LocalNotifications,
    private locationAccuracy: LocationAccuracy,
    private geolocation: Geolocation,
    private androidPermissions: AndroidPermissions,
  ) {
    this.presentView = "homePageBody";
    // _translate.setDefaultLang('en');
    // _translate.use('en');
    if (this.platform.is('ios')) {
      this.localNotification.on('click').subscribe(async res => {
        console.log('NOTIFICATION CLICK clicked = ', res);
        if (res.data.chatType == "individualChats") {
          if (this.router.url === '/tabs/tab5') {
            // this.individualChat(res.data.roomID);
          } else {
            this.router.navigate(['/tabs/tab5']);
            console.log('Navigating to tab5');
            // this.individualChat(res.data.roomID);
          }
        }
        else {
          console.log("success")
          // this.router.navigate(['/tabs/tab5']);
          // this.groupChat(res.data.roomID)
        }
      });
      this.localNotification.on('trigger').subscribe(res => {
        console.log(' CLICK trigger = ', res);
      });
    }
  }
  public commonAnd = CommonService;
  theNotify: any;
  async ngOnInit() {
    this.platform.ready().then(() => {
      this.checkGPSPermission();
    });
    this.androidCheckNotificationPermissions();


    const wasPermissionGiven: boolean = await this.fcm.requestPushPermission({
      ios9Support: {
        timeout: 10,  // How long it will wait for a decision from the user before returning `false`
        interval: 0.3 // How long between each permission verification
      }
    })


    if (this.platform.is('android')) {
      console.log("android");
      this.fcm.onNotification().subscribe(async (data: { wasTapped: any; }) => {
        console.log('Notification', data);
        console.log('Notification Data JSON:', JSON.stringify(data));

        if (localStorage.getItem("temNotification") != localStorage.getItem("globalNotificationDuplicate")) {
          this.theNotify = String(Math.floor((Math.random() * 10) + 1));
          localStorage.setItem("temNotification", this.theNotify);
        } else {
          this.theNotify = localStorage.getItem("temNotification");
        }


        // const localNotificationDuplicate = data['gcm.message_id'];
        const globalNotificationDuplicate = localStorage.getItem("globalNotificationDuplicate");
        if (data.wasTapped) {
          console.log('Received in background');
        } else {
          console.log('Received in subscribe foreground');
          console.log('Received in foreground onNotificazion == ', JSON.stringify(data));
          this.localPushNotificationTitle = data["title"];
          this.localPushNotificationContent = data["body"];
          if(this.localPushNotificationTitle != '' && this.localPushNotificationContent != ''){
            this.localPushNotificationTitle = (this.localPushNotificationTitle.length > 35) ? this.localPushNotificationTitle.substring(0,35) + '...' : this.localPushNotificationTitle;
            this.localPushNotificationContent = (this.localPushNotificationContent.length > 130) ? this.localPushNotificationContent.substring(0,130) + '...' : this.localPushNotificationContent;
            let obj = {
              title: this.localPushNotificationTitle,
              body: this.localPushNotificationContent,
              lang: localStorage.getItem('selectedLanguage')
            }
            this.sendNotification.emit(obj);
          }
          // @ts-ignore
          // ----------notificationSDK33
          // if (data["notification_foreground"] == "true") {
          //   console.log('notification_foreground' + 'true');
          //   this.localNotification.getDefaults();
          //   this.showNotification(data)
          //   // if (globalNotificationDuplicate != this.theNotify) {
          //   //   localStorage.setItem("globalNotificationDuplicate", this.theNotify);
          //   //   this.showNotification(data)
          //   // } else {
          //   //   localStorage.setItem("temNotification", "one");
          //   // }
          // } else {
          //   console.log('No Notification', data);
          // }
        }
      });
    } else {
      console.log("ios");
      this.fcm.onNotification().subscribe(async (data: { wasTapped: any; }) => {
        console.log('Notification', data);
        console.log('Notification Data JSON:', JSON.stringify(data));
        const localNotificationDuplicate = data['gcm.message_id'];
        const globalNotificationDuplicate = localStorage.getItem("globalNotificationDuplicate");
        if (data.wasTapped) {
          console.log('Received in background');
        } else {
          console.log('Received in subscribe foreground');
          console.log('Received in foreground onNotificazion == ', JSON.stringify(data));
          // @ts-ignore
          if (data["notification_foreground"] == "true") {
            console.log('notification_foreground' + 'true');
            this.localNotification.getDefaults();
            if (globalNotificationDuplicate != localNotificationDuplicate) {
              localStorage.setItem("globalNotificationDuplicate", localNotificationDuplicate);
              this.showNotification(data)
            }
          } else {
            console.log('No Notification', data);
          }
        }
      });
    }







    // this.fcm.onNotification().subscribe(async (data: { wasTapped: any; }) => {
    //   console.log('Notification', data);
    //   console.log('Notification Data JSON:', JSON.stringify(data));
    //   if (data.wasTapped) {
    //     console.log('Received in background');
    //   } else {
    //     console.log('Received in subscribe foreground');
    //     console.log('Received in foreground onNotificazion == ', JSON.stringify(data));
    //     // @ts-ignore
    //     if (data["notification_foreground"] == "true") {
    //       console.log('notification_foreground' + 'true');
    //       this.localNotification.getDefaults();
    //       this.showNotification(data)
    //     } else {
    //       console.log('No Notification', data);
    //     }
    //   }
    // });






    // if (localStorage.getItem("patient_id")) {
    //   this.askPermission();
    // }








    // this.addCall.language = localStorage.getItem("selectedLanguage") ? localStorage.getItem("selectedLanguage") : "en";
    // this.addCall.selectedLanguage = localStorage.getItem("selectedLanguage") ? localStorage.getItem("selectedLanguage") : "en";

    // if (this.addCall.selectedLanguage == 'ea') {
    //   var root = document.documentElement;
    //   root.setAttribute('style', '--direction:rtl');
    // } else if (this.addCall.selectedLanguage == 'en') {
    //   var root = document.documentElement;
    //   root.setAttribute('style', '--direction:ltr');
    // }

    // this._initTranslate(this.addCall.language);

    //this.faceIDAuthentication();
    this.tymVal = window.localStorage['HomeADD'];
    // console.log(this.tymVal,"======================================================<><><><><===");
    let CD = new Date().toISOString().split("T")[0] + "T" + new Date().toTimeString().split(" ")[0];
    // console.log("tymVal -> ", this.tymVal, "\nCD     -> ", CD);
    // if (this.tymVal == 0 || CD >= this.tymVal) {
    //   if (window.localStorage['isAddOpened'] == 0) {
    //     this.addCall.getAdd(1, "Home");
    //   }
    // }
    //this.addCall.getAdd(1, "Home");
    /*console.log("totalWidth=>", screen.width);
    setTimeout(() => {
      const gesture: Gesture = this.gestureCtrl.create({
        el: this.rectangle.nativeElement,
        threshold: 15,
        gestureName: 'my-gesture',
        onMove: ev => this.onMoveHandler(ev)
      });
      gesture.enable(true);
      console.log("gesture Start");
      console.log("gesture", gesture);
    }, 20000);*/
  }



  getLocation() {
    try {
      let options = {
        enableHighAccuracy: true,
        timeout: 5000
      };
      this.geolocation.getCurrentPosition(options).then((resp) => {
        this.commonAnd.setAndLat(resp.coords.latitude ?? 29.62107798734671);
        this.commonAnd.setAndLong(resp.coords.longitude ?? 47.587719496877924);
        // this.lattitude = 29.62107798734671;
        // this.longititude = 47.587719496877924;
      }, err => {
        this.commonAnd.setAndLat(29.62107798734671);
        this.commonAnd.setAndLong(47.587719496877924);
        console.log('home getting location', err);
      });
    } catch (e) {
      console.log('home page geolocation', e);
    }


  }

  androidCheckNotificationPermissions() {
    document.addEventListener('deviceready', function () {

      var permissions = cordova.plugins.permissions;

      permissions.requestPermission(permissions.POST_NOTIFICATIONS, successCallback, errorCallback);

      function successCallback() {
        console.log('POST_NOTIFICATIONS permission granted');

      }

      function errorCallback() {

        console.log('POST_NOTIFICATIONS permission denied');

      }

    }, false);
  }


  onMoveHandler(el) {
    //  console.log(el);
    const type = el.type;
    const currentX = el.currentX;
    const deltaX = el.deltaX;
    const velocityX = el.velocityX;
    var xvalue = Math.round(currentX);
    var xvalue2 = String(xvalue);
    var xvalue3 = xvalue2 + "px"

    if (xvalue <= screen.width && xvalue >= 135) {
      //console.log("true");
      if (xvalue == screen.width - 50) {
        this.rectangle.nativeElement.style.marginLeft = screen
      }
      else {
        this.rectangle.nativeElement.style.marginLeft = xvalue3;
      }
      //  console.log("margin-left=>", this.rectangle.nativeElement.style.marginLeft);
    }
    else {
      console.log("false");
    }


  }


  doRefresh(event) {
    //  console.log('Begin async operation');

    setTimeout(() => {
      //  console.log('Async operation has ended');
      event.target.complete();
    }, 2000);
  }

  ionViewWillEnter() {
    this.checkGPSPermission();
    localStorage.setItem("notificationActiveMenuId", "1");
    this.common.videoSound = false;
    this.common.setDoctorDetails(false);
    console.log(this.common.videoSound, "VideoSound");

    this.get_VCvalidation()
    // this.URL = this.services.API_URL;
    this.specialitylistcall();
    this.storeNoOfApmnts = window.localStorage["storeNoOfApmnts"];
    this.presentView = "homePageBody";
    this.homePageHead = true;
    this.homePageBody = true;
    this.hideSlide = true;
    this.showSlide = false;
    console.log("elementRefer=>", this.addCall.selectedLanguage);
    this.getPatientBasicDetails();
    // this.getAppoinmentCount();
    // this.Notificationcount();
    this.membergender = localStorage.getItem("Gender");
    console.log(this.membergender, "gender");
    if (this.membergender == null) {
      this.presentLoading();
    }
    // if(this.membergender.length >  1){
    //   this.presentLoading()
    // }
    // this.vc_notification();
    // this.auth.checkAuth().then(data=>{
    //   this.route.navigate(['/tabs/home']);
    // })
    this.addCall.checkTranslate()
    let data = JSON.stringify({
      "patient_id": localStorage.getItem("patient_id"),
      "language": localStorage.getItem("selectedLanguage")
    })
    const insertPatientLanguage = this.services.postRequest("insert_patient_language", data).subscribe(req => {
      console.log(req);
    })
    this.apiSubscriptions.push(insertPatientLanguage);
    // enable
     this.vaccinationcheckreminder();
    this.getFCMToken();
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      cssClass: 'my-custom-class',
      message: 'Please wait...',
      duration: 3000
    });
    await loading.present();
    // console.log('Loading dismissed!');
  }


  openNotification() {
    this.router.navigate(['/tabs/notification']);
  }

  showProfile() {
    localStorage.setItem("profileFlow", "MenWomen");
    this.router.navigate(['/tabs/profile']);
    // console.log("Men Or Women Flow");

    /* if (this.patientBasicDetails.patientType == 1 || this.patientBasicDetails.patientType == 2) {
       localStorage.setItem("profileFlow", "MenWomen");
       this.router.navigate(['/tabs/profile']);
       console.log("Men Or Women Flow");
     }
     else if (this.patientBasicDetails.patientType == 3) {
       localStorage.setItem("profileFlow", "pregnantFlow");
       this.router.navigate(['/tabs/pregnant-mother']);
       console.log("Pregnet Women Flow");
     }
     else if (this.patientBasicDetails.patientType == 4) {
       localStorage.setItem("profileFlow", "motherFlow");
       this.router.navigate(['/tabs/pregnant-mother']);
       console.log("Pregnent Mother Flow");
     }*/
  }

  openSpeciality(type) {
    this.router.navigate(['/tabs/speciality', { speciality_name: type }]);
  }

  goToNursing() {
    this.router.navigate(['/tabs/nursing']);
    localStorage.setItem("NopayGoBack", "newEnter");
  }

  openRoomBooking() {
    this.router.navigate(['/tabs/booking-room']);

    localStorage.setItem("NopayGoBack", "newEnter");
  }

  goLabPage() {
    debugger;
    this.router.navigate(['/tabs/lab']);

    localStorage.setItem("NopayGoBack", "newEnter");
  }

  godietMealPage() {
    this.router.navigate(['/tabs/dietmeal']);
    localStorage.setItem("NopayGoBack", "newEnter");
  }

  openAppointments() {
    this.router.navigate(['/tabs/appointments']);
  }

  open_Notification(value, picsrc, id) {
    console.log(value, picsrc, id)
    //  console.log(picsrc);
    if (id == 6) {
      if (this.patientBasicDetails.gender == 'male' || this.patientBasicDetails.gender == 'Male') {
        picsrc = 'assets/img/trainer-new.png';
      } else if (this.patientBasicDetails.gender == 'female' || this.patientBasicDetails.gender == 'Female') {
        picsrc = 'assets/img/trainer-new.png';
      }
    }

    this.router.navigate(['/tabs/commonNotification', { module: value, modulepic: picsrc, moduleid: id }])
  }


  goTrainingCenter() {
    this.router.navigate(['/tabs/trainingCenter']);

    localStorage.setItem("NopayGoBack", "newEnter");
  }
  openPrescription() {
    this.router.navigate(['/tabs/prescription', { frmPage: 'Details' }]);

    localStorage.setItem("NopayGoBack", "newEnter");
  }
  goToTrainer() {
    this.router.navigate(['/tabs/trainer']);

    localStorage.setItem("NopayGoBack", "newEnter");
  }
  goPhysitherapy() {
    // this.router.navigate(['/tabs/physiotherapy']);
    this.router.navigate(['/tabs/newphysiotherapy']);

    localStorage.setItem("NopayGoBack", "newEnter");
  }
  openDoctorsList() {
    this.router.navigate(['/tabs/doctors-list', { id: 0 }]);
    localStorage.setItem("specId", "0");
    // console.log("specelityId=>", localStorage.getItem("specId"));
  }
  openReport() {
    this.router.navigate(['/tabs/report']);
  }
  goDoctor() {
    this.router.navigate(['/tabs/doctors-list', { id: 9 }]);
  }
  goPhysitherapyDoc() {
    this.router.navigate(['/tabs/doctors-list', { id: 14 }]);
  }

  goDermatologist() {
    this.router.navigate(['/tabs/doctors-list', { id: 7 }]);
  }


  showSlides() {
    this.hideSlide = false;
    this.showSlide = true;
  }
  hideSlides() {
    this.hideSlide = true;
    this.showSlide = false;
  }
  swipeLeftEvent(event) {
    console.log(event);
  }


  getPatientBasicDetails() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });
    // console.log("send patient Basic Reqst=>", JSON.parse(apiData));
    const getPatientProfile = this.services.postRequest("getPatientProfile", apiData).subscribe(res => {
      //  console.log(res);
      // this.loadingController.dismiss();
      this.PatientProfileDetails = res.data[0];
      this.patientBasicDetails = res.data[0];
      this.common.profileImage = res.data[0].profile_image;
      localStorage.setItem("Gender", this.patientBasicDetails.gender);
      localStorage.setItem("Email", this.patientBasicDetails.email);
      localStorage.setItem("Patient_Profile", this.patientBasicDetails.profile_image);
      localStorage.setItem("patientName", this.patientBasicDetails.name);
    });
    this.apiSubscriptions.push(getPatientProfile);
  }

  getAppoinmentCount() {
    let apiData = JSON.stringify({
      "currentDate": new Date().toISOString().split("T")[0],
      "patientId": localStorage.getItem("patient_id"),
      "current_time": new Date().toTimeString().split(" ")[0]
    });
    const patientBookedCount = this.services.postRequest("patientBookedAppointmentListCount", apiData).subscribe(res => {
      console.log(res);
      this.storeNoOfApmnts = res.data.details[0].upCommingAppointmentCount;
      window.localStorage["storeNoOfApmnts"] = this.storeNoOfApmnts;
      // console.log("NoOfApmnts=>", this.storeNoOfApmnts);
    });
    this.apiSubscriptions.push(patientBookedCount);
  }





  //regidter

  insertDetails() {
    let apiData = JSON.stringify({
      "name": "ajith121",
      "dob": "1995-06-04",
      "email": "test121@gmail.com",
      "phone_no": "9715392758",
      "gender": "male",
      "address": "Thanjavur"
    });
    const insdertPatientDetials = this.services.postRequest("insertPatientDetails", apiData).subscribe(res => {
      console.log(res);
    });
    this.apiSubscriptions.push(insdertPatientDetials);
  }


  getFCMToken() {

    //this.platform.ready().then(() => {
    if (this.platform.is('android') || this.platform.is('ios')) {
      this.fcm.getToken().then(token => {
        console.log(token);
        this.sendToken(token);
      });
    } else {
      console.log('Browser');
    }
    //});
  }

  async openVideoCall(id, password, name) {
    const modal = await this.modalCtrl.create({
      component: VcalertPage,
      cssClass: 'vc-alert',
      componentProps: {
        meetingid: id,
        password: password,
        name: name
      },
      backdropDismiss: false
    });
    /* modal.onDidDismiss()
     .then((data) => {
       this.ModalOpened=false;
       const response = data['data'];
       if(response){
         console.log(response);
         this.succesPage(response.status, response.msg);
       }
     });*/
    return await modal.present();
  }

  sendToken(token) {
    let request = JSON.stringify({
      "patient_id": localStorage.getItem("patient_id"),
      "token": token
    });
    const insertpatienttoken = this.services.postRequest("insert_patient_token", request).subscribe(response => {
      localStorage.setItem("FCM", token);
    });
    this.apiSubscriptions.push(insertpatienttoken);
  }




  async vc_notification(type, VCdetails) {

    let popup = await this.modalCtrl.create({
      component: HomeVcNotificationPage,
      componentProps: {
        showtype: type,
        Docname: VCdetails.doctorName,
        timeleft: VCdetails.MINUTEDIFFERENCE
      },
      cssClass: 'vc-alert'
    })
    await popup.present();

    popup.onDidDismiss().then((data) => {
      console.log(data);
      if (data.data == "yes") {
        this.getVdoConf(VCdetails)
      }

    })
  }


  Notificationcount() {

    let apidate = JSON.stringify({
      "memberId": localStorage.getItem("patient_id"),
      "notificationDate": new Date().toISOString().split("T")[0],
      "app_language": localStorage.getItem("selectedLanguage")
    })

    const getMemberNotificationsCount = this.services.postRequest("getMemberNotificationsCount", apidate).subscribe(res => {
      console.log(res.data);

      this.NotificationCount = res.data;
      let getnoti = [];
      let intcount = 0;
      getnoti.push(res.data)
      //  console.log(this.NotificationCount);
      for (const key in getnoti) {
        console.log(key);
        for (let nestedKey in getnoti[key]) {
          console.log(getnoti[key][nestedKey].count, "nestkey");
          intcount += getnoti[key][nestedKey].count
        }

      }
      this.common.commonNotification = intcount;
      this.totalNotificationsCount = intcount;
      localStorage.setItem("Nofycount", this.totalNotificationsCount)
      console.log(intcount);
    })
    this.apiSubscriptions.push(getMemberNotificationsCount);
    // this.playAudio();
    // this.onAudioPlay();
    // this.playSound();
  }


  OpenChat() {
    this.router.navigate(['/tabs/chat']);
  }

  SplDetail: any = [];

  specialitylistcall() {
    let data = JSON.stringify({
      "speciality": "",
      "foldername": "specialityPath"
    })
    const getdoctorspecialitylist = this.services.postRequestGndrl("admin/getdoctorspecialitylist", data).subscribe(req => {
      console.log(req);
      this.SplDetail = req;
    })
    this.apiSubscriptions.push(getdoctorspecialitylist);
  }

  goDoctorSpl(item) {
    // console.log('doctor spl',item.id,item.speciality);

    localStorage.setItem("specId", item.id);
    this.router.navigate(['/tabs/doctors-list', { id: item.id, speciname: item.speciality, frmSplHome: true }]);
  }

  faceIDAuthentication() {
    let self = this;
    if (this.platform.is("ios")) {
      CID.checkAuth("For login purpose", function (res) {
        console.log(res);
        if (res == 'success') {
          alert('success');
        } else if (res == 'User cancelled') {
          localStorage.clear();
          self.router.navigate(['/login']);


          //   console.log(res);
        }
      }, function (err) {
        console.log(err);
      });
    }
  }
  // async languageChange() {

  //    const modal = await this.modalCtrl.create({
  //     component: ChangeLanguagePage,
  //     cssClass: 'languageModal',

  //   });
  //   modal.onDidDismiss().then((message => {
  //   console.log("message==>",message);
  //   }))

  //   return await modal.present();
  // }



  // async ChangeLanguage() {

  //   const modal = await this.modalCtrl.create({
  //     component: ChangeLanguagePage,
  //     cssClass: 'my-custom-modal-css',
  //     // cssClass: 'languageModal',
  //     backdropDismiss: true

  //   });
  //   modal.onDidDismiss().then((message => {
  //     console.log("message ==>", message);
  //     this.language = message.data;
  //     this.addCall.selectedLanguage = message.data;
  //     this.changeLanguage();

  //     if (this.language == 'ea') {
  //       var root = document.documentElement;
  //       root.setAttribute('style', '--direction:rtl');
  //     } else if (this.language == 'en') {
  //       var root = document.documentElement;
  //       root.setAttribute('style', '--direction:ltr');
  //     }
  //   }))

  //   return await modal.present();
  // }


  ionViewDidEnter(): void {
    this.getDeviceLanguage()
  }

  public changeLanguage(): void {
    console.log("language", this.language);
    this._translateLanguage();
  }

  _translateLanguage(): void {
    this._translate.use(this.language);
    this.addCall.initialiseTranslation();
  }

  _initTranslate(language: any) {
    // Set the default language for translation strings, and the current language.
    this._translate.setDefaultLang('en');
    if (language) {
      this.language = language;
    }
    else {
      // Set your language here
      this.language = 'en';
    }
    this._translateLanguage();
  }


  getDeviceLanguage() {
    if (window.Intl && typeof window.Intl === 'object') {
      this._initTranslate(navigator.language)
    }
    else {
      this.globalization.getPreferredLanguage()
        .then(res => {
          this._initTranslate(res.value)
        })
        .catch(e => { console.log(e); });
    }
  }





  async ChangeLanguage() {

    console.log(this.homeToggle);
    if (this.homeToggle == true) {
      this.addCall.selectedLanguage = "ea";
      this.language = "ea";
      // this.AlertInfo("The Language has been changed to Engish", 22)
    } else if (this.homeToggle == false) {
      this.addCall.selectedLanguage = "en";
      this.language = "en";
      // this.AlertInfo("The Language has been changed to Engish", 23)
    }
    localStorage.setItem("selectedLanguage", this.addCall.language);
    localStorage.setItem("selectedLanguage", this.addCall.selectedLanguage);
    // this.language = message.data;
    // this.addCall.selectedLanguage = message.data;
    this.changeLanguage();

    if (localStorage.getItem("selectedLanguage") == 'ea') {
      var root = document.documentElement;
      root.setAttribute('style', '--direction: rtl');
      let data = JSON.stringify({
        "patient_id": localStorage.getItem("patient_id"),
        "language": "ea"
      })
      const insert_patient_language = this.services.postRequest("insert_patient_language", data).subscribe(req => {
        console.log(req);
      })
      this.apiSubscriptions.push(insert_patient_language);
    } else if (localStorage.getItem("selectedLanguage") == 'en') {
      var root = document.documentElement;
      root.setAttribute('style', '--direction: ltr');
      let data = JSON.stringify({
        "patient_id": localStorage.getItem("patient_id"),
        "language": "en"
      })
      const insert_patient_language = this.services.postRequest("insert_patient_language", data).subscribe(req => {
        console.log(req);
      })
      this.apiSubscriptions.push(insert_patient_language);
    }
  }



  async askPermission() {
    let popup = await this.modalCtrl.create({
      component: PopupalertPage,
      componentProps: {
        // 'msg': this.addCall.title535,
        'msg': "Allow TOM To Access Your Location For Distance Services!",
        'sts': 2,
      },
      cssClass: 'class_alert'
    })
    await popup.present();
  }



  get_VCvalidation() {
    let apiData = JSON.stringify({
      "patientId": localStorage.getItem("patient_id"),
      "currentDate": new Date().toISOString().split("T")[0],
      "currentTime": new Date().toTimeString().split(" ")[0]
    });

    const getvcValidate = this.services.postRequest("getvcValidate", apiData).subscribe((res => {
      let data = res?.data?.details[0]

      console.log(data);

      if (data.VC_Doctor_status == 1) {
        //this.vc_notification("show_alert", "")
        // this.vc_notification('wait_alert', data)
        return
      }
      else if (data.MINUTEDIFFERENCE > 0 && data.MINUTEDIFFERENCE <= 5 && data.book_date == new Date().toISOString().split("T")[0]) {
        // this.vc_notification("show_alert", data)
      }



    }))
    this.apiSubscriptions.push(getvcValidate);

  }

  async getVdoConf(data) {
    console.log(data);
    this.update_vcStatus(data.bookingId)
    this.videocall.joinJitsiMeeting(data.doc_vc_room, data.doctorName, "", "");
  }

  update_vcStatus(booking_id) {
    let apiData = JSON.stringify({
      "bookingId": booking_id,
      "approvalStatus": "1",
      "type": "MemberVC"
    });
    const updateVCApprovalStatus = this.services.postRequest("updateVCApprovalStatus", apiData).subscribe(res => {
      console.log(res);

    });
    this.apiSubscriptions.push(updateVCApprovalStatus);
  }

  showNotification(data: any) {
    console.log("Show notification true");
    console.log("data[title] = " + data["title"]);
    console.log("data[body] = " + data["body"]);
    console.log("data[roomID] = " + data["roomID"]);
    //this.localNotification.getDefaults();
    this.localNotification.requestPermission().then(
      (permission) => {
        console.log('Permission granted: ', permission);
      },
      (error) => {
        console.error('Error requesting permission: ', error);
      }
    );
    try {
      this.localNotification.schedule({
        id: new Date().getTime(),
        title: data["title"],
        text: data["body"],
        //sound: '',
        data: { roomID: data["roomID"], chatType: data["chatType"] },
        trigger: { in: 0.1, unit: ELocalNotificationTriggerUnit.SECOND },
        foreground: true,
      });
    } catch (e: any) {
      console.log("Show notification true error message = " + e.message);
    }
  }

  ngOnDestroy() {
    this.apiSubscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }


  vaccinationcheckreminder() {
    try {
      let apiData = {
        "patientId": localStorage.getItem("patient_id"),
      }
      this.services.postRequestGndrl("Patient/checkVaccinationReminder", apiData).subscribe(res => {
        let data = res.data
        let Details = this.PatientProfileDetails.patientmemberDetails
        let myres = [];
        let datgd = [];
        for (const response of data) {
          for (const memberDetail of Details) {
            if (response.infant_patient_id === memberDetail.PatientMemberId.toString()) {
              myres.push(response);
              datgd.push(memberDetail);
              if (response.app_alert_ntification_send != '1') {
                this.showVaccinationReminder(response);
              }
            }
          }
        }
      })
    } catch (error) {
      console.log("error", error);
    }

  }

  async showVaccinationReminder(matchingPatient) {
    let popup = await this.modalCtrl.create({
      component: VaccinepopupPage,
      componentProps: {
        'data': matchingPatient,
        'VaccinationReminderstatus': 1,
      },
      cssClass: 'class_alert'
    })
    popup.onDidDismiss().then((data) => {
      try {
        if (data.data) {
          console.log(data.data, 'datas');
          let apiData = {
            "isComplete": 0,
            "recordId": data.data
          }
          this.services.postRequestGndrl("Patient/updateInfantListDetails", apiData).subscribe(res => {
            console.log(res);
          })
        }
      } catch (error) {
        console.log("error", error);
      }

    });
    await popup.present();
  }
  // ionViewWillLeave() {
  //   this.apiSubscriptions.forEach(subscription => {
  //     subscription.unsubscribe();
  //   });
  // }

  checkGPSPermission() {
    this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION).then(
      result => {
        if (result.hasPermission) {
          this.askToTurnOnGPS();
        } else {
          this.requestGPSPermission();
        }
      },
      err => {
        console.error('Error checking permission', err);
      }
    );
  }

  requestGPSPermission() {
    this.androidPermissions.requestPermission(this.androidPermissions.PERMISSION.ACCESS_FINE_LOCATION).then(
      result => {
        if (result.hasPermission) {
          this.askToTurnOnGPS();
        } else {
          console.error('Permission not granted');
        }
      },
      err => {
        console.error('Error requesting permission', err);
      }
    );
  }

  askToTurnOnGPS() {
    this.locationAccuracy.canRequest().then((canRequest: boolean) => {
      if (canRequest) {
        this.locationAccuracy.request(this.locationAccuracy.REQUEST_PRIORITY_HIGH_ACCURACY).then(
          () => {
            this.getLocation();
          },
          error => console.error('Error requesting location accuracy', error)
        );
      } else {
        // GPS is already enabled
        this.getLocation();
      }
    });
  }
}


